export enum FileUploadRejectionReason {
  DUPLICATE = "duplicate",
  MAX_FILES = "max-files"
}
